import isSignedIn from './isSignedIn';
import presenceStore from '../store/presenceStore';
import getMySipUri from './getMySipUri';
import type InstantMessagePresenceType from 'owa-service/lib/contract/InstantMessagePresenceType';
import { getStore } from '../store/chatStore';
import ChatProvider from '../store/schema/ChatProvider';

import { default as dispatchPresenceForUcma } from '../ucma/presenceManager/dispatchPresenceUpdateFromHeader';
import { default as dispatchPresenceForUcwa } from '../ucwa/presenceManager/dispatchPresenceUpdateFromHeader';

export default function dispatchPresenceUpdateFromHeader(newPresence: InstantMessagePresenceType) {
    const storePresence = presenceStore.presences.get(getMySipUri());
    const currentPresence = isSignedIn() && storePresence !== undefined ? storePresence : 'Offline';
    if (newPresence != currentPresence) {
        const chatProvider = getStore().chatProvider;

        if (chatProvider == ChatProvider.UCMA) {
            dispatchPresenceForUcma(currentPresence, newPresence);
        } else if (chatProvider == ChatProvider.UCWA) {
            dispatchPresenceForUcwa(currentPresence, newPresence);
        }
    }
}
